<template>
<div class="manager_dashboard">
  <user-menu />
  <div class="wrapper" style="background-color: #FFF;">
    <mentee-sidebar-menu v-if="checkIsMentee()" :show_menu="true" :show_back_button="false" />
  <ManagerSidebarMenu v-if="checkIsManager() || ($store.state.switch_admin_username && !entepriseAdmin)" :show_menu="true" :show_back_button="false" back_link="managerReports"></ManagerSidebarMenu>
  <MentorSidebarMenu v-if="checkIsMentor()" :show_menu="true" :show_back_button="false" back_link="mentorReports"></MentorSidebarMenu>
    <div class="content-wrapper" style="background-color: #FFF; padding-left: 165px; ">
      <div class="container-wrapper center">
      <div style="text-align: center;">
          <flash-message autoHide variant="success"></flash-message>
      </div>
    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
      {{ success_message }}
    </b-alert>

      <div class="row">
          <div>
            <h3 class="heading text-uppercase mb-3" style="padding-left: 10px;">My Badges</h3>
          </div>
      </div>
       

        <div class="row">
            <div class="col-6 pr-3 pr-xl-5">

             <div class="shadow rounded px-3 py-3" v-if="checkIsManager() || checkIsMentor() || checkIsMentee() || ($store.state.switch_admin_username && !entepriseAdmin)">
          
            <div class="row align-items-end">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 10px;">Assessments</div>
                        </div>
                    </div>
                    <div style="clear: both; margin-bottom: 20px;" ></div>
                    <div class="col-12 p-0" v-if="assessments.length > 0">
                        <div class="assessment-section border-bottom mb-3 pb-2" v-for="(assessment, aindex) in assessments" :key="aindex">
                        <div class="row align-items-center  mx-1" style="margin-left: 0 !important">
                        <div class="col-1" style="padding-left: 0px;">
                          <div class="progress-circle" >
                            <img src="@/assets/mm_logo_small.png" class="my-badge-logo-wrapper" />
                          </div>
                        </div>
                          <div class="col-7 pl-4">
                            <p class="mb-0">{{ assessment.title }}</p>
                            <p class="small text-muted mb-0" v-if="assessment.complete_attempt_id">Assessment Completed {{ assessment.completionDate }}</p>
                          </div>
                          <div class="col-4 pr-0 text-right" style="padding-left: 5px;" v-if="assessment.complete_attempt_id">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="viewReport(assessment.complete_attempt_id)"  >View Results <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                          </div>
                          <div class="col-4 pr-0 text-right" v-else style="padding-left: 5px;">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="goToAssessmentLanding(assessment.id, assessment.inprogress_attempt_id)"  >Start 
                              <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
                            </a>
                          </div>
                        </div>






                        </div>
                    </div>
                    <div class="col-12 mt-2 db-empty-card p-0" v-else>
                        <div class="db-empty-card">
                            <h6 class="empty-content-title">No Assessments Assigned</h6>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>

        
          <div style="clear: both; margin-bottom: 20px;" ></div>

          <div class="shadow rounded px-3 py-3" v-if="checkIsManager() || checkIsMentor() || checkIsMentee() || ($store.state.switch_admin_username && !entepriseAdmin)">
          
            <div class="row align-items-end">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 10px;">Courses</div>
                        </div>
                    </div>
                    <div style="clear: both; margin-bottom: 20px;" ></div>
                    <div v-if="courseLoading == false">
                    <div class="col-12 p-0" v-if="courses.length > 0">
                        <div class="assessment-section border-bottom mb-3 pb-2" v-for="(course, cindex) in courses" :key="cindex">
                        <div class="row align-items-center mx-1" style="margin-left: 0 !important">
                          <div class="col-1" style="padding-left: 0px;">
                          <div class="progress-circle" v-if="course.type == 'External'">
                            <img :src="course.image" class="my-badge-logo-wrapper" />
                          </div>
                          <div class="progress-circle" v-else>
                            <img src="@/assets/mm_logo_small.png" class="my-badge-logo-wrapper" />
                          </div>
                          </div>
                          <div class="col-7 pl-4" v-if="course.type == 'External'">
                            <p class="mb-0">{{ course.title }}</p>
                            <p class="small text-muted mb-0" >External Course {{ course.expires }}</p>
                          </div>
                          <div class="col-7 pl-4" v-else>
                            <p class="mb-0">{{ course.title }}</p>
                            <p class="small text-muted mb-0" v-if="course.certification_download_link">Course Completed {{ course.completedOn }}</p>
                          </div>
                          <div class="col-4 pr-0 text-right" style="padding-left: 5px;" v-if="((course.certification_download_link != '') && (course.type == 'Internal'))">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="viewCourseReport(course.certification_download_link)"  >View Certificate <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                          </div>
                          <div class="col-4 pr-0 text-right" style="padding-left: 0px;" v-else-if="((course.buttonName == 'Upload Certification'))">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="openCourseCertificationModal(course.id, course.stepObjectiveId)"  >{{ course.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                          </div>
                          <div class="col-4 pr-0 text-right" style="padding-left: 0px;" v-else-if="((course.buttonName == 'View Certificate'))">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="downloadCourseFunc(course.certification_download_link)"  >{{ course.buttonName }} <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>
                          </div>
                          <div class="col-4 pr-0 text-right" v-else-if="course.type == 'Internal'" style="padding-left: 0px;">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="goToCourseLanding(course.lmsCourseId, course.lmsUserId)"  >{{getCourseBtnName(course.certification_download_link, course.courseStatus)}} 
                              <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
                            </a>
                          </div>
                        </div>






                        </div>
                    </div>
                    <div class="col-12 mt-2 db-empty-card p-0" v-else>
                        <div class="db-empty-card">
                            <h6 class="empty-content-title">No Courses Assigned</h6>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        
        </div>
          

          <div style="clear: both; margin-bottom: 15px;" ></div>

          <div class="shadow rounded px-3 py-3" v-if="checkIsManager() || checkIsMentor() || checkIsMentee() || ($store.state.switch_admin_username && !entepriseAdmin)">
          
            <div class="row align-items-end">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 10px;">Forms</div>
                        </div>
                    </div>
                    <div style="clear: both; margin-bottom: 20px;" ></div>
                    <div class="col-12 p-0" v-if="forms.length > 0">
                        <div class="assessment-section border-bottom mb-3 pb-2" v-for="(form, findex) in forms" :key="findex">
                        <div class="row align-items-center mx-1 " style="margin-left: 0 !important">
                        <div class="col-1" style="padding-left: 0px;">
                          <div class="progress-circle" >
                            <img src="@/assets/mm_logo_small.png" class="my-badge-logo-wrapper" />
                          </div>
                        </div>
                          <div class="col-7 pl-4">
                            <p class="mb-0">{{ form.name }}</p>
                            <p v-if="form.checkSubmissionResultId" class="small text-muted mb-0" >Form Completed {{ form.completionDate }}</p>
                          </div>
                          <div class="col-4 pr-0 text-right" style="padding-left: 5px;" v-if="form.checkSubmissionResultId">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="goToViewForm(form.id)" style="">View Form <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" /></a>

                            <br />
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="openMenteeEditFormModal(form.id, form.userId)" style=" padding-right: 30px;">Edit Form </a>


                          </div>
                          <div class="col-4 pr-0 text-right" v-else style="padding-left: 5px;">
                            <a class="progress_item_link branding_text_color font-weight-bold" @click="openMenteeFillFormModal(form.id)" >Fill Form
                              <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
                            </a>
                          </div>
                        </div>






                        </div>
                    </div>
                    <div class="col-12 mt-2 db-empty-card p-0" v-else>
                        <div class="db-empty-card">
                            <h6 class="empty-content-title">No Forms Assigned</h6>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                
     


        <div style="clear: both; margin-bottom: 20px;" ></div>  



            </div>

            <div class="col-6 pr-3 pr-xl-5">


          <div class="shadow rounded px-3 py-3" v-if="checkIsMentee() || checkIsMentor()">
          
            <div class="row align-items-end">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                            <div class="h6 mb-0 font-weight-bold" style="padding-bottom: 10px;">Certifications</div>
                        </div>
                    </div>
                    <div style="clear: both; margin-bottom: 20px;" ></div>
                   
                     <div style="margin-bottom: 7px; float: left; width: 100%;" v-if="loading == true">

                  <div class="row pb-2 mx-2 mb-2 border-class" style="border-bottom: 1px solid #CCC;" v-for="option in 3">
                    <div class="col-1" style="padding-left: 0px;">
                      <PuSkeleton circle height="45px" width="45px"  :count="1"></PuSkeleton>
                    </div>

                    <div class="col-7 col-xl-8 pt-1 pl-3" >
                      <div class="col-8 p-0">
                      <PuSkeleton :count="2"></PuSkeleton>
                      </div>
                    </div>
                    <div class="col-4 col-xl-3 text-right pt-3" style="padding-left: 0px; padding-right: 0px;" >
                      <PuSkeleton :count="1"></PuSkeleton>
                    </div>
                  </div>
                  
                </div>


    <div class="mentee-progress-list" v-if="certificates.length == 0 && loading == false">
      <div class="row" style="">
        <div class="col-11" style="padding-left: 15px; font-style: italic;">
          No certification found
        </div>
      </div>      
    </div>


    <div class="mentee-progress-list">
    <div class="border-class mb-3 align-items-center pl-3 pr-3 pb-2" v-for="(item, index) in certificates">
    <div class="row" style="">
      <div class="col-1" style="padding-left: 0px;">
        <div class="progress-circle" >
          <img :src="item.image" class="my-badge-logo-wrapper" />
        </div>
      </div>

      <div class="col-6 col-xl-7 pt-1 pl-4" >
        <p class="mb-0">{{ item.name }}</p>
        <p class="small text-muted mb-0" v-if="item.menteeCertificateExpires">Certification - {{ item.menteeCertificateExpires }}</p>
      </div>
      <div class="col-5 col-xl-4 text-right pt-2" style="padding-left: 0px; padding-right: 5px;" v-if="(item.buttonName == 'Upload Certification')">
        <a class="progress_item_link branding_text_color font-weight-bold" style="color: #00ACEE;" @click="uploadCertificationModalOpen(item.id, item.stepObjectiveId)"> {{ item.buttonName }}
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>     
      <div class="col-5 col-xl-4 text-right pt-2" style="padding-left: 0px; padding-right: 5px;" v-if="item.buttonName == 'View Certificate'">
        <a class="progress_item_link branding_text_color font-weight-bold" style="color: #00ACEE;" @click="downloadFunc(item.menteeCertificatename)"> {{ item.buttonName }}
          <img v-if="$isBranding != 1" class="ml-2 objective-view-icon" src="@/assets/manager/reps_to_review_arrow.png" />
        </a>
      </div>
    </div>
    </div>
    </div>
                   
                </div>
            </div>
        </div>
                
        </div>
    </div>

        <div style="clear: both; margin-bottom: 20px;" ></div>

    </div>
   </div>  
 </div> 


    <MenteeAssessmentLandingPage 
      :isModalVisible="isAssessmentLandingVisible"
      @closeAssessmentLandingModal="closeAssessmentLandingModal"
      @openAssessmentQuestionModal="openAssessmentQuestionModal"
      ref="MenteeAssessmentLandingModal">
    </MenteeAssessmentLandingPage>

    <MenteeAssessmentQuestionPage 
      :isModalVisible="isAssessmentQuestionVisible"
      @closeAssessmentQuestionModal="closeAssessmentQuestionModal"
      ref="MenteeAssessmentQuestionModal">
    </MenteeAssessmentQuestionPage>

    <MenteeFillForm 
      :isModalVisible="isMenteeFillFormVisible"
      @closeMenteeFillFormModal="closeMenteeFillFormModal"
      ref="MenteeFillFormModal">
    </MenteeFillForm>

    <MenteeEditForm 
      :isModalVisible="isMenteeEditFormVisible"
      @closeMenteeEditFormModal="closeMenteeEditFormModal"
      ref="MenteeEditFormModal">
    </MenteeEditForm>

    <div v-if="isMenteeUploadComponentVisible">
   <MenteeUploadCertificate 
      :isModalVisible="isMenteeUploadComponentVisible"
      :type="2"
      @close="uploadCertificationModalClose"
      @closeMenteeUploadModal="uploadCertificationModalClose"
      ref="MenteeUploadModal">
    </MenteeUploadCertificate>
    </div>

    <div v-if="isCourseCertificationModalVisible">
    <MenteeUploadCourseCertifications 
      :isModalVisible="isCourseCertificationModalVisible"
      :type="2"
      @close="closeCourseCertificationModal"
      @closeTaskListModal="closeCourseCertificationModal"
      ref="CourseCertificationModal">
    </MenteeUploadCourseCertifications>
    </div>


</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import GoBack from './shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../router/index.js';
import { store } from '../store/store';
import UserMenu from './shared/user_menu.vue';
import {ValidationMethods} from './shared/common_validations.js';
import MenteeSidebarMenu from '@/components/shared/mentee_sidebar_menu.vue';
import MenteeAssessmentLandingPage from '@/components/mentee/mentee_assessment_landing_new.vue';
import MenteeAssessmentQuestionPage from '@/components/mentee/mentee_assessment_question_new.vue';
import MenteeFillForm from '@/components/mentee/mentee_fill_form_new.vue';
import MenteeEditForm from '@/components/mentee/mentee_update_form_new.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import { checkIsManager, checkIsMentor, checkIsMentee } from '@/components/shared/utils.js';
import MenteeUploadCertificate from '@/components/manager/mentee_upload_certificate.vue';
import MenteeUploadCourseCertifications from '@/components/manager/mentee_upload_course_certificate.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  mixins: [ValidationMethods],
  data() {
   return {     
      pageName: 'MY PROFILE',
      is_mentee: 0,
      showBackButton: false,  
      userId: '',
      forms: [],
      assessments: [], 
      certificates: [],
      entepriseAdmin: false,
      researcher: false,
      csr: false,
      isAssessmentLandingVisible: false,
      isAssessmentQuestionVisible: false,
      isMenteeFillFormVisible: false,
      isMenteeEditFormVisible: false,
      loading: false,
      success_message: '',
      dismissCountDown: 0,
      courses: [],    
      isMenteeUploadComponentVisible: false,
      isCourseCertificationModalVisible: false,
      menteeId: '',
      certId: '',
      currentStepId: '',
      stepId: '',
      menteeShortName: '',
      mentorsAssigned: [],
      courseLoading: false,
    }
  },
  components: {
    GoBack,
    UserMenu,
    MenteeSidebarMenu,   
    MenteeAssessmentLandingPage,
    MenteeAssessmentQuestionPage,
    MenteeFillForm,
    MenteeEditForm,
    ManagerSidebarMenu,
    MentorSidebarMenu,
    MenteeUploadCertificate,    
    MenteeUploadCourseCertifications,
  },
  methods: {    
    downloadCourseFunc: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/course_certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
    openCourseCertificationModal(courseId, objectiveId) {
      this.isCourseCertificationModalVisible = true;
      setTimeout(() => { 
      this.$refs.CourseCertificationModal.getMenteeCertificatesData(this.menteeId, courseId, this.currentStepId, objectiveId);
      }, 500);
    },
    closeCourseCertificationModal() {
      this.getMyBadgesCourses();
      this.isCourseCertificationModalVisible = false;
    },
    getMyBadgesCourses() {
      this.courses = [];
      this.courseLoading = true;
      axios.get('/desktop/user/course-lists/' + this.$store.state.user_accountid, {
      })
      .then(response =>  {
        this.courseLoading = false;
        this.courses = response.data.course;
      })
      .catch(function() {
        console.log("Come here");
      });

    },
    
    checkIsMentor() {
      return checkIsMentor();
    },
    checkIsManager() {
      return checkIsManager();
    },
    checkIsMentee() {
        return checkIsMentee();
    },
    truncate: function (text) {
            if (text.length > 35) {
                return text.substring(0, 35) + '...';
            } else {
                return text;
            }
    },
     getCourseBtnName(certificate, courseStatus) {
      var res = 'Begin';
        if(certificate) {
          res = 'Re-Take';
        }
        else if(courseStatus == 1) {
          res = 'Continue';
        }
       return res;
     },
    viewCourseReport: function(url) {
        window.open(url, '_blank');
    },
    openMenteeFillFormModal(formId) {
      this.$refs.MenteeFillFormModal.getFormData(formId);
      this.isMenteeFillFormVisible = true;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    closeMenteeFillFormModal(flag) {
      if(flag == 1) {
        this.success_message = 'Form successfully completed!';
        this.dismissCountDown = 5;
        this.getReloadForms();
      }
      this.isMenteeFillFormVisible = false;
    },
    openMenteeEditFormModal(formId, userId) {
      this.$refs.MenteeEditFormModal.getFormData(formId, userId);
      this.isMenteeEditFormVisible = true;
    },
    closeMenteeEditFormModal(flag) {
      if(flag == 1) {
        this.success_message = 'Form edited successfully!';
        this.dismissCountDown = 5;
      }
      this.isMenteeEditFormVisible = false;
    },
    goToCourseLanding(courseId, lmsUserId) {
      var dashboardPath = this.$route.fullPath;
      dashboardPath = dashboardPath.replace(/^\/+/,"");
     
      router.push('/take-course/'+ lmsUserId + '/' + dashboardPath + '?c=' + courseId);
    },
    closeAssessmentLandingModal() {
      this.isAssessmentLandingVisible = false;
    },
    openAssessmentQuestionModal(assessmentId, assessmentAttemptId) {
      this.$refs.MenteeAssessmentQuestionModal.getScaleLists(assessmentId, assessmentAttemptId);
      this.isAssessmentLandingVisible = false;
      this.isAssessmentQuestionVisible = true;
    },
    closeAssessmentQuestionModal () {
      this.isAssessmentQuestionVisible = false;
    },
    viewReport: function(id) {
           let routeData = this.$router.resolve({name: 'assessmentreportnew', params: {assessmentAttemptId: id}});
            window.open(routeData.href, '_blank');
    },
    goToAssessmentLanding: function(assessmentId, assessmentAttemptId, questionCount) {
        if(assessmentAttemptId) {
          this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, assessmentAttemptId);
          this.isAssessmentLandingVisible = true;
        }
        else {
          axios('/desktop/user-assessment-attempts/' + assessmentId + '/' + this.$store.state.user_accountid,
          {
            method: 'POST',
          })
          .then((resp) => {
             this.$refs.MenteeAssessmentLandingModal.getLandingPageContent(assessmentId, resp.data);
             this.isAssessmentLandingVisible = true;
          })
          .catch(() => {

          });
        }
    },        
    isUser() {
      if(this.$route.params.user_id) {
          return false;
      }
      else {
          return true;
      }
    },    
    goBack() {
      this.$router.go(-1)
    },
    goToViewForm(formId) {
      if (this.$store.state.user_accountid) {
        var formViewUrl = '/desktop/forms-manager/view-form/'+formId+'/' + this.$store.state.user_accountid;
      } else {
        if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          formViewUrl = '/forms-manager/view-form/'+formId;
        }
      }
      
     axios.get(formViewUrl, {
      })
      .then(response =>  {        
        window.open(process.env.API_ENDPOINT + '/web/forms/' +response.data.filepath, '_blank');                        
      })
      .catch(function(err) {
        console.log("Come here"+ err);
      });
    },
    getReloadForms() {
        var userAccountId = '';
        if(store.state.user_accountid) {
          userAccountId = store.state.user_accountid;
        }
      if ((userAccountId)) {
        var formSubmittedUrl = '/my-profile/user/form-lists/' + userAccountId;  
      } else {
        if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
          formSubmittedUrl = '/user/submitted-form-lists';
        }
      }
      axios.get(formSubmittedUrl, {
      })
      .then(response =>  {
        this.forms = response.data;
      })
      .catch(function() {
        
      });

    },
     getMenteeCertificatesData(menteeId, certId, stepId) {
      this.menteeId = menteeId;
      this.loading = true;
      this.certId = certId;
      this.stepId = stepId;
      this.certificates = [];

       axios('/desktop/v2/get-mentee-certification-my-badges', {
        method: 'GET',
        params: {         
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.loading = false;
        this.certificates = resp.data.certificates;
      })
      .catch(() => {});
     
    },
    uploadCertificationModalOpen(certId, stepObjectiveId) {
      this.isMenteeUploadComponentVisible = true;
      setTimeout(() => { 
      this.$refs.MenteeUploadModal.getMenteeCertificatesData(this.menteeId, certId, this.currentStepId, stepObjectiveId);
      }, 500);
    },
    uploadCertificationModalClose() {
      this.getMenteeCertificatesData(this.menteeId, this.certId, this.stepId);
      this.isMenteeUploadComponentVisible = false;
    },
    downloadFunc: function(fileName) {
      this.apiUrl = process.env.API_ENDPOINT;
      var url = this.apiUrl + '/web/certificates/' + fileName;
      window.open(url, '_blank');
      return false;    
    },
  },
  created: function() {
    this.courseLoading = true;
    var roles = this.$store.state.roles;
    if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
      this.masterAdmin = true;
    }
    if(roles.indexOf('ROLE_RESEARCHER') > -1) {
      this.researcher = true;
    }
    if(roles.indexOf('ROLE_CSR') > -1) {
      this.csr = true;
    }
    if(roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
      this.entepriseAdmin = true;
    }
    if(
      ((roles.indexOf('ROLE_ADMIN') > -1)
      ||
      (this.$store.state.switch_admin_username))
      &&
      ((this.$store.state.switch_flag != 'Instructor')
      &&
      (this.$store.state.switch_flag != 'Mentor'))
      ) {
      this.admin = true;
    }

    if(
      ((roles.indexOf('ROLE_MENTOR') > -1)
      ||
      (roles.indexOf('ROLE_MENTEE') > -1)
      ||
      (roles.indexOf('ROLE_INSTRUCTOR') > -1)
      ||
      (roles.indexOf('ROLE_STUDENT') > -1))
      &&
      ((this.$store.state.switch_flag != 'Manager')
      &&
      (this.$store.state.switch_flag != 'Primary Admin'))
      ) {
      this.showBackButton = true;
    }
    this.loading = true;
    document.body.className = 'profile-page';
  
    var userAccountId = '';
    if(store.state.user_accountid) {
      userAccountId = store.state.user_accountid;
    }
   
    if(!this.entepriseAdmin && !this.researcher && !this.csr) 
    {
      this.getReloadForms();
      if((!this.researcher) && (!this.csr)) {
      axios.get('/desktop/user/assessment-lists/' + this.$store.state.user_accountid, {
      })
      .then(response =>  {
        this.assessments = response.data.assessment;
      })
      .catch(function() {
        console.log("Come here");
      });
      this.getMyBadgesCourses();

      }
    }

    if(checkIsMentee() || checkIsMentor()) {
        axios('/desktop/v2/get-mentee-certification-my-badges', {
        method: 'GET',
        params: {         
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        this.loading = false;
        this.certificates = resp.data.certificates;
      })
      .catch(() => {})
      axios('/desktop/v2/get-mentee-details', {
        method: 'GET',
        params: {
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let data = resp.data;
        this.menteeId = data.mentee_id;
        this.menteeShortName = data.mentee_short_name;
        this.mentorsAssigned = data.mentors_assigned;
      })
      .catch(() => {});

   }
    
  
  },
  
}
</script>

<style scoped>
.content-wrapper {
  padding-top: 75px;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}

.db-card {
  background-color: #FFF;
  border: 1px solid  #CCC;
  width: 99%;
  min-height: 10px;
  padding: 10px;
  margin: 0px 0 0px 0;
  border-radius: 10px;  

}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 0px;
}
/* .grid_row .cols { padding: 0; } */
.db-card .label_txt {
  font-weight: 400;
  margin-bottom: 5px;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
.dbViewBtn{
  color: #00acee !important;
  background-color: #FFF;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  width: 50px;
  float: right;
}
.dbViewBtn:focus, .dbViewBtn:active {
  color: #00acee !important;
  background-color: #FFF !important;
  border: 1px solid #00acee !important;
} 
.user-icon{ font-size: 60px;  margin-bottom: 10px; }
.mentor_row { margin: 30px; }
.db-card .title{
  font-size: 15px;
  font-weight: 900;
}
.db-card .db-report-card {
  background-color: #FFF;
  border-radius: 0px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #FFF;
  border-radius: 0px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
  font-style: italic;
}
a.dbEditBtn {
  color: #00ACEE !important;
  border: 0px solid #29A3E4;
  background: none;
  font-size: 13px;
  font-weight: 900;
  padding: 5px;
  line-height: 8px;
  text-decoration: underline !important;
  text-align: right;
}
a.dbEditBtn {
  width: 50px;
  float: right;
  margin-top: 0px;
}
.dbEditBtn:focus, .dbEditBtn:hover {
  color: #00acee !important;
  background:none !important;
  border: 0px solid #00acee !important;
  box-shadow: none !important;
} 

.dbGoalBtn {
  text-decoration: underline;
  color: #7d7d7d !important;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.view-mentee-hr {
    margin-top: 5px;
    margin-bottom: 0px;
    border: 1px solid #00ACEE;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}



.dialogbox .body {
  position: relative;
  max-width: 300px;
  height: auto;
  margin: 20px 10px;
  padding: 5px;
  border-radius: 3px;
  border: 5px solid #ccc;
}

.body .message {
  min-height: 30px;
  border-radius: 3px;
  font-family: Arial;
  font-size: 14px;
  line-height: 1.5;
  color: #797979;
}
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(100%, 0);
    }
    .slide-leave-to {
      transform: translate(-100%, 0);
    }
.profile-page .main-wrapper {
   background-color: #FFF;
   padding: 10px;
   min-height: 400px;
   transform: none;
   margin-top:20px;
   width: 50%;
}
@media(max-width:768px) {
  .profile-page .main-wrapper {
     width: 70%;
   }
}
@media (max-width: 560px) {
 .profile-page .main-wrapper {
    border-radius: 5px;
    width: 100%;
  }
}
@media (max-width: 575.98px) {
  .col-xs-1 {
   width: 8.33333333%;
  }
  .col-xs-11 {
    width: 91.66666667%;
  }
  .col-xs-4 {
    width: 33.333333%;
  }
  .col-xs-8 {
    width: 66.666667%;
  }
  .col-xs-9 {
    width: 75%;
  }
  .col-xs-3 {
    width: 25%;
  }
}
.content-main-wrapper h3 {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  color: #555;
}
.marginbot10 {
  margin-bottom: 10px;
}
.profile-heading {
  margin-top: 10px;
}
label {
  font-size: 12px;
}
.profile-sec-sep {
  border-top: 1px solid #DDD;
  margin: 20px 0px 20px 0px;
}
#profile-link-wrapper .profile-link {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}
#edit-profile-wrapper label {
  padding-left: 0px;
}
.edit-profile-wrapper .submit{
  padding-right: 15px;
  margin-top: 10px;
}
.custom-chkbox {
  width: 10%;
  float: left;
}
label.group-chkbox {
  font-weight: normal;
}
.roles { text-transform: capitalize; }
.profile-container label{
  font-weight:bold;
}
.profile-container .chkboxwrapper label{
  font-weight:normal;
}

.edit-profile-wrapper {
  padding-top: 10px;
}
.question_text, .question_text a, .question_text a:hover {
  font-size: 11px;
  color: #002F42;
}
.color-blue a, .color-blue a:hover{
  color: #29A3E4 !important;
  text-decoration: underline;
  font-weight: bold;
}
.start-button {
    color: #29A3E4;
    background-color: #FFF !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 110px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4 !important;
    border: 1px solid #29A3E4 !important;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 87px; 
}
.content-main-wrapper {
  width: 100%;
  background-color: #FFF;
  padding: 0px;
  margin-bottom: 0px;
}
.personal-details-wrapper {
  padding-left: 5%;
  padding-right: 5%;   
}
.custom-select {
    height: 25px;
    padding: 0;
    padding-left: 10px;
}
.preference-heading {
    font-size: 14px;
}
.ma-blue-btn1 {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
.ma-white-btn1 {
  color: #00ACEE !important; 
  background-color: #FFF !important;
  border: 1px solid #00ACEE !important;
  font-weight: 900;
  border-radius: 10px;
  width: 120px;
}
body.profile-page {
    background: none;
}
.objective-view-icon {
  width: 15px;
  margin-left: 5px !important;
}
.db-card a {
    color: #00ACEE !important;
}
a {
    cursor: pointer;
}
.col-12 .border-bottom:last-child {
    border: 0 !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.my-badge-logo-wrapper {
  width: 50px;
  border: 1px solid #dee2e6;
  padding: 5px;
  border-radius: 10px;
  box-shadow: 0 0px 5px rgba(0,0,0,.15) !important;
}

.empty-content-title {
  font-size: 14px;
}
.db-empty-card {
  font-style: italic;
  
}
</style>



// WEBPACK FOOTER //
// src/components/my_badges.vue